import * as React from "react";
export const ConfluenceIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={31} height={30} viewBox="0 0 31 30" {...props}>
      <defs>
        <linearGradient
          id="grd1"
          gradientUnits="userSpaceOnUse"
          x1="29.361"
          y1="31.795"
          x2="10.019"
          y2="20.68"
        >
          <stop offset="0.18" stop-color="#0052cc" />
          <stop offset="1" stop-color="#2684ff" />
        </linearGradient>
        <linearGradient
          id="grd2"
          gradientUnits="userSpaceOnUse"
          x1="8300.239"
          y1="-23997.611"
          x2="7133.229"
          y2="-24333.48"
        >
          <stop offset="0.18" stop-color="#0052cc" />
          <stop offset="1" stop-color="#2684ff" />
        </linearGradient>
      </defs>
      <g id="Layer_2">
        <g id="Blue">
          <path
            id="Layer"
            fill="url(#grd1)"
            d="M1.1 22.88C0.78 23.4 0.42 24.01 0.11 24.49C0.05 24.6 0.01 24.72 -0.01 24.85C-0.03 24.98 -0.03 25.1 0 25.23C0.04 25.35 0.09 25.47 0.16 25.57C0.24 25.67 0.33 25.76 0.44 25.83L6.84 29.76C6.95 29.83 7.07 29.88 7.2 29.9C7.33 29.92 7.46 29.91 7.59 29.88C7.72 29.85 7.84 29.8 7.94 29.72C8.05 29.64 8.14 29.54 8.2 29.43C8.46 29 8.79 28.45 9.15 27.85C11.68 23.67 14.23 24.18 18.83 26.38L25.17 29.39C25.29 29.45 25.42 29.48 25.55 29.48C25.68 29.49 25.81 29.47 25.93 29.42C26.06 29.38 26.17 29.31 26.27 29.22C26.36 29.13 26.44 29.02 26.49 28.9L29.54 22.01C29.59 21.9 29.62 21.77 29.62 21.64C29.62 21.51 29.6 21.39 29.56 21.27C29.51 21.15 29.44 21.04 29.35 20.95C29.27 20.85 29.16 20.78 29.05 20.72C27.71 20.1 25.05 18.84 22.65 17.69C14.03 13.5 6.7 13.77 1.1 22.88Z"
          />
          <path
            id="Layer"
            fill="url(#grd2)"
            d="M29.78 7.26C30.1 6.74 30.46 6.13 30.76 5.65C30.83 5.54 30.87 5.42 30.89 5.29C30.91 5.17 30.9 5.04 30.87 4.91C30.84 4.79 30.79 4.67 30.71 4.57C30.64 4.47 30.54 4.38 30.43 4.31L24.04 0.38C23.93 0.3 23.8 0.25 23.67 0.23C23.53 0.2 23.4 0.21 23.27 0.24C23.13 0.27 23.01 0.32 22.9 0.4C22.79 0.48 22.7 0.59 22.63 0.7C22.38 1.13 22.05 1.69 21.69 2.28C19.16 6.46 16.61 5.95 12.01 3.76L5.69 0.76C5.57 0.7 5.44 0.67 5.31 0.66C5.18 0.66 5.05 0.68 4.92 0.72C4.8 0.77 4.69 0.84 4.59 0.93C4.49 1.02 4.42 1.13 4.36 1.25L1.32 8.13C1.27 8.25 1.24 8.38 1.24 8.51C1.23 8.63 1.26 8.76 1.3 8.88C1.35 9 1.41 9.11 1.5 9.2C1.59 9.29 1.69 9.37 1.81 9.42C3.15 10.05 5.81 11.31 8.21 12.46C16.85 16.64 24.18 16.36 29.78 7.26Z"
          />
        </g>
      </g>
    </svg>
  );
};
